import {withRouter} from 'react-router';
import {isEmpty as _isEmpty} from 'lodash';

import DefaultForm from '@appComponents/DefaultForm';
import {getLink} from '@appComponents/Link';
import {dropdownOptionParser} from '@utils/dropdownOptionParser';
import {syncOriginEntryPointMultiselects} from '@utils/originEntryPointFormHelper';

import {prepareFailoversForDropdown} from '../utils/formHelpers';

const UDP_ENTITY_KEY = 'udpOriginEntryPoint';

export class UdpOriginEntryPointForm extends DefaultForm {
    componentDidMount() {
        const link = this.createLinkToIndexPage();

        this.setOptionParsers({
            ad_splice_config: dropdownOptionParser,
        });
        this.setCreateSuccessCallback(() => {
            this.props.history.push(link);
        });
        this.setDeleteSuccessCallback(() => {
            this.props.history.push(link);
        });
        this.setUpdateSuccessCallback(() => {
            this.props.history.push(link);
        });
    }

    componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        const adSupportChanged = prevProps.formValues.has_scte35 !== this.props.formValues.has_scte35;

        if (adSupportChanged) {
            this.setField('ad_splice_config', {
                hidden: !this.props.formValues.has_scte35,
                required: true,
            });
        }

        if (undefined !== this.props.GraphQLOptionsData) {
            const {
                GraphQLOptionsData: {
                    udpOriginEntryPoints,
                },
            } = this.props;

            if (!this.state.areFailoverOptionsGenerated && !_isEmpty(udpOriginEntryPoints)) {
                const failoversForDropdown = prepareFailoversForDropdown(udpOriginEntryPoints, this.props.formParams.id);

                this.setField('failoverUdpOriginEntryPoint', {
                    options: failoversForDropdown,
                });
                this.setState(() => ({areFailoverOptionsGenerated: true}));
            }

            syncOriginEntryPointMultiselects(this, UDP_ENTITY_KEY);
        }
    }

    createLinkToIndexPage = () => (
        getLink('udpOriginEntryPoint.index')
    );

    prepareDataForSubmit = (data) => {
        return (undefined === data)
            ? null
            : {
                ...this.props.Model.dataMap[this.props.Model.entityDataMapKey],
                contentCategories: data.content_categories,
                description: data.description || null,
                encodingDatacenter: data.encoding_datacenter,
                failoverUdpOriginEntryPoint: _isEmpty(data.failover_udp_origin_entry_point)
                    ? null
                    : data.failover_udp_origin_entry_point,
                id: data.id || null,
                name: data.name,
                previewUrl: data.preview_url || null,
                tournaments: data.tournaments,
                url: data.url,
                adSpliceConfig: data.has_scte35 ? data.ad_splice_config : null,
                hasCc: !!data.has_cc,
                hasScte35: !!data.has_scte35,
            };
    };

    renderErrors() {
        super.renderErrors(
            'The requested UDP origin entry point could not be found.',
            this.props.Model.entityLabel,
            this.createLinkToIndexPage()
        );
    }

    renderCancelButton = () => null;
}

export default withRouter(UdpOriginEntryPointForm);
